const pepOptions = [
  {
    value: "pending",
    option: "Pending",
  },
  {
    value: "yes",
    option: "Yes",
  },
  {
    value: "no",
    option: "No",
  },
];

const idvOptions = [
  {
    value: "blocked",
    option: "Blocked",
  },
  {
    value: "pending",
    option: "Pending",
  },
  {
    value: "processing",
    option: "Processing",
  },
  {
    value: "pass",
    option: "PASS",
  },
  {
    value: "fail",
    option: "FAIL",
  },
];

const idTypes = [
  { value: "driving_licence", label: "Driving Licence" },
  { value: "health_services_card", label: "Health Services Card" },
  { value: "id_card", label: "ID Card" },
  { value: "passport", label: "Passport" },
  { value: "residence_permit", label: "Residence Permit" },
  { value: "visa", label: "Visa" },
];

const sailorConfig = { pepOptions, idvOptions, idTypes };
export default sailorConfig;
